/*
 * Return the CDN URL for an asset
 * @param {String} the relative path to the asset
 * @return {String} the full path to the asset
 */
import { OV_CDN, OV_VERSION } from '../config/theme';

var cdnSrc = function cdnSrc(src) {
  // When the src is absolutely pathed, just return it.
  if (src.indexOf('http') === 0 || src.indexOf('//') === 0) {
    return src;
  }

  return "".concat(OV_CDN, "shopify/").concat(OV_VERSION, "/").concat(src);
};

export default cdnSrc;